import { ContentCopy, Share } from '@mui/icons-material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';
import { homeStyles } from '.';
import { ConferenceCall } from './mobile-live-bar';

export const ShareCallButton = (props: { call: ConferenceCall }) => {
  // Props
  const { call } = props;
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title:
            call.day === 0
              ? `Check out ${call.name}!`
              : `The ${call.name} is live! Check it out!`,
          text: 'This is an awesome link I wanted to share with you.',
          url: props.call.youtube,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(props.call.youtube).then(() => {
        setSnackbarMessage('Link copied to clipboard!');
        setOpenSnackbar(true);
      });
    }
  };

  return (
    <React.Fragment>
      <Button
        fullWidth
        size="small"
        sx={{ ...homeStyles.button, '.MuiButton-endIcon': { marginLeft: 0 } }}
        endIcon={<Share fontSize="small" sx={{ transform: 'scale(0.7)' }} />}
        onClick={handleShare}
      >
        Share
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={() => setOpenSnackbar(false)}
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        }
      />
    </React.Fragment>
  );
};
